import { render, staticRenderFns } from "./PageTerms.vue?vue&type=template&id=61877194&"
import script from "./PageTerms.vue?vue&type=script&lang=js&"
export * from "./PageTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports